module.exports = __webpack_public_path__ + "img/erjian_gaoji-1.f7543bed.png";